/**
 * Created by why on 2019/8/17.
 */
import {
  roleList,
  roleInsert,
  roleDelete,
  roleUpdate,
  findByIdRole,
  getMenuTree,
  editMenu,
  roleAllList
} from '@/api/role-manage'
import {
  getMenuByRouter
} from '@/libs/util'
export default {
  state: {
    list: [],
    roleList: [],
    roleLoading: false,
    loadingSave: false,
    loadingDelete: false,
    loadingUpdate: false,
    pageSize: 10,
    pageNum: 1,
    total: 0,
    data: null,
    messageInfo: null,
    menuList: [],
    roleAllList: []
  },
  mutations: {
    setRolesList (state, roleList) {
      state.list = roleList
    },
    setRoleLoading (state, loading) {
      state.roleLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
    setLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    },
    setData (state, data) {
      state.data = data
    },
    setMessageInfo (state, data) {
      state.messageInfo = data
    },
    setLoadingDelete (state, loading) {
      state.loadingDelete = loading
    },
    setRoleList (state, list) {
      state.roleList = list
    },
    setMenuList (state, list) {
      state.menuList = list
    },
    setRoleAllList (state, list) {
      state.roleAllList = list
    }
  },
  getters: {
    roleList: state => state.list,
    roleLoading: state => state.roleLoading,
    roleTotal: state => state.total,
    messageInfo: state => state.messageInfo,
    loadingSave: state => state.loadingSave,
    roleList1: state => state.roleList,
    menuList1: state => state.menuList,
    roleAllList: state => state.roleAllList
  },
  actions: {
    getRoleList ({ state, commit }, {pageNum, pageSize, sort, order}) {
      commit('setRoleLoading', true)
      return new Promise((resolve, reject) => {
        roleList({
          pageNum: pageNum,
          pageSize: pageSize,
          sort: sort,
          order: order
        }).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.size
          const pageNum = data.current
          const total = data.total
          commit('setRolesList', list)
          commit('setRoleLoading', false)
          commit('setPageSize', pageSize)
          commit('setPageNum', pageNum)
          commit('setTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setRoleLoading', false)
          reject(err)
        })
      })
    },
    roleInsert ({ state, commit }, data) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        roleInsert(data).then(res => {
          commit('setLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    roleDelete ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        roleDelete(id).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    roleUpdate ({ state, commit }, data) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        roleUpdate(data).then(res => {
          commit('setLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    findByIdRole ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        findByIdRole({id: id}).then(res => {
          const data = res.data
          commit('setRoleList', data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getMenuTree ({ state, commit }, status) {
      return new Promise((resolve, reject) => {
        getMenuTree(status).then(res => {
          const data = res.data.result
          commit('setMenuList', data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    editMenu ({ state, commit }, data) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        editMenu(data).then(res => {
          commit('setLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    allRole ({ state, commit }) {
      return new Promise((resolve, reject) => {
        roleAllList().then(res => {
          commit('setRoleAllList', res.data.result)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    setData ({ commit }, {type, id, roleName, remark, pageSize, pageNum, list}) {
      let dataState = this.state.data
      switch (type) {
        case 'query' :
          let data = {...dataState, ...{id}}
          return new Promise((resolve, reject) => {
            commit('setData', data)
            resolve()
          })
        case 'page' :
          return new Promise((resolve, reject) => {
            commit('setPageSize', pageSize)
            commit('setPageNum', pageNum)
            resolve()
          })
        case 'role' :
          let dataRole = {...dataState, ...{roleId: id}}
          return new Promise((resolve, reject) => {
            commit('setData', dataRole)
            resolve()
          })
        case 'delete' :
          let deleteData = {...dataState, ...{id}}
          return new Promise((resolve, reject) => {
            commit('setData', deleteData)
            resolve()
          })
        case 'save' :
          let saveData = {...dataState, ...{roleName, remark}}
          return new Promise((resolve, reject) => {
            commit('setData', saveData)
            resolve()
          })
        case 'update' :
          let updateData = {...dataState, ...{id, roleName, remark}}
          return new Promise((resolve, reject) => {
            commit('setData', updateData)
            resolve()
          })
        case 'editMenu' :
          let menuData = {...dataState, ...{list: list, roleId: id}}
          return new Promise((resolve, reject) => {
            commit('setData', menuData)
            resolve()
          })
        default :
          return new Promise((resolve, reject) => {
            resolve()
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/role-manage.js